var exception = {exports: {}};

export { exception as e };
